function Foobar() {

    this.foo = function () {
        return "foo";
    };

    this.speak = function () {
        return this.name || "please define this.name";
    };
};

module.exports = Foobar;


// WEBPACK FOOTER //
// ./src/models/Foobar.js